import {
    DIMENSION_LIST_REQUEST,
    DIMENSION_LIST_RESPONSE,
    DIMENSION_LIST_CACHED_RESPONSE,
    DIMENSION_LIST_ERROR_RESPONSE,
    DIMENSION_LIST_COUNT_REQUEST,
    DIMENSION_LIST_COUNT_RESPONSE,
    DIMENSION_LIST_COUNT_CACHED_RESPONSE,
    DIMENSION_LIST_COUNT_ERROR_RESPONSE,
    DIMENSION_ITEM_REQUEST,
    DIMENSION_ITEM_RESPONSE,
    DIMENSION_ITEM_CACHED_RESPONSE,
    DIMENSION_ITEM_ERROR_RESPONSE,
    DIMENSION_ITEM_SAVE_REQUEST,
    DIMENSION_ITEM_SAVE_RESPONSE,
    DIMENSION_ITEM_SAVE_ERROR_RESPONSE,
    DIMENSION_WIZARD_REQUEST,
    DIMENSION_WIZARD_RESPONSE,
    DIMENSION_WIZARD_ERROR_RESPONSE
} from "./action-types"

import {
    itemRequest,
    itemResponse,
    itemCachedResponse,
    itemErrorResponse,
    itemSaveRequest,
    itemSaveErrorResponse
} from "./default-actions/entity-actions"

import {
    listRequest,
    listResponse,
    listCachedResponse,
    listErrorResponse
} from "./default-actions/paging-actions"

// Paging Request/Response Actions
export const dimensionListRequest = listRequest(DIMENSION_LIST_REQUEST)
export const dimensionListResponse = listResponse(DIMENSION_LIST_RESPONSE)
export const dimensionListErrorResponse = listErrorResponse(
    DIMENSION_LIST_ERROR_RESPONSE
)
export const dimensionListCachedResponse = listCachedResponse(
    DIMENSION_LIST_CACHED_RESPONSE
)

// List Count Request/Response Actions
export const dimensionListCountRequest = listRequest(
    DIMENSION_LIST_COUNT_REQUEST
)
export const dimensionListCountResponse = listResponse(
    DIMENSION_LIST_COUNT_RESPONSE
)
export const dimensionListCountErrorResponse = listErrorResponse(
    DIMENSION_LIST_COUNT_ERROR_RESPONSE
)
export const dimensionListCountCachedResponse = listCachedResponse(
    DIMENSION_LIST_COUNT_CACHED_RESPONSE
)

// Entity Request/Response Actions
export const dimensionItemRequest = itemRequest(DIMENSION_ITEM_REQUEST)
export const dimensionItemResponse = itemResponse(DIMENSION_ITEM_RESPONSE)
export const dimensionItemErrorResponse = itemErrorResponse(
    DIMENSION_ITEM_ERROR_RESPONSE
)
export const dimensionItemCachedResponse = itemCachedResponse(
    DIMENSION_ITEM_CACHED_RESPONSE
)
export const dimensionItemSaveRequest = itemSaveRequest(
    DIMENSION_ITEM_SAVE_REQUEST
)
export const dimensionItemSaveResponse = itemResponse(
    DIMENSION_ITEM_SAVE_RESPONSE
)
export const dimensionItemSaveErrorResponse = itemSaveErrorResponse(
    DIMENSION_ITEM_SAVE_ERROR_RESPONSE
)
export const dimensionWizardRequest = (
    partialDimension,
    callbackActionCreator
) => ({
    type: DIMENSION_WIZARD_REQUEST,
    ...partialDimension,
    callbackActionCreator
})
export const dimensionWizardResponse = itemResponse(DIMENSION_WIZARD_RESPONSE)
export const dimensionWizardErrorResponse = (
    error,
    partialDimension,
    callbackActionCreator
) => ({
    type: DIMENSION_WIZARD_ERROR_RESPONSE,
    ...partialDimension,
    callbackActionCreator
})
